/* import __COLOCATED_TEMPLATE__ from './table-loading.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();